<template>
  <div class="ended-popup-component">
    <ym-popup class="ended-popup-content"
              v-model="visible"
              get-container="body"
              :close-on-click-overlay="close"
    >
      <div class="ended-popup-hint">
        <h2 class="ended-popup-hint-title">周年庆活动已经结束</h2>
        还有部分优惠继续进行中
      </div>
      <div class="ended-popup-btn"
           @click="visible = false"
      >点击查看</div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'EndedPopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      close: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ended-popup {
    &-content {
      box-sizing: border-box;
      width: 520px;
      padding: 40px 30px;
      font-size: 28px;
      line-height: 1.6;
      text-align: center;
      border-radius: 12px;
    }
    &-hint {
      &-title {
        margin: 0 auto 10px;
        font-size: 32px;
      }
      &::after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        margin: 20px auto 0;
        border-width: 10px;
        border-style: solid;
        border-color: #13b9bf transparent transparent transparent;
      }
    }
    &-btn {
      width: 300px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-radius: 15px;
      color: #fff;
      background-color: #13b9bf;
      margin: 10px auto 0;
    }
  }
</style>
